import React, { useRef } from 'react';
import {
  TextField,
  ListBase,
  ListToolbar,
  Pagination,
  FunctionField,
  Datagrid,
} from 'react-admin';

import { Card } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { formatTelefone } from '../../utils';
import Dialogo from './ContainerDialogoProduto';
import DialogoDeleteResource from './DialogoDeletar';
import Filter from './Filter';
import {} from '../../utils/dadosTelas';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';

const MyList = ({ ...props }) => {
  const refDialogoCompra = useRef(null);
  const refDialogoDeleteResource = useRef(null);

  function handleCriar() {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleCreate();
    }
  }
  function handleEdit({ id }) {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleEdit(id);
    }
  }
  function deleteHundle(record) {
    if (refDialogoDeleteResource.current)
      refDialogoDeleteResource.current.handleOpen(record);
  }

  return (
    <>
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList handleCriar={handleCriar} {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Datagrid {...props}>
          <TextField source="id" label="ID" />
          <TextField source="nome" label="Nome" />
          <FunctionField
            label="Telefone"
            render={(record) => formatTelefone(record.telefone)}
          />
          <ActionsField
            source="lalala"
            textAlign="right"
            label="Ações"
            sortable={false}
            /* handleEdit={handleEdit}
            handleShow={handleShow} */
            actions={[
              {
                key: 'editar',
                title: 'Editar',
                icon: <EditOutlinedIcon />,
                onClick: (rec) => handleEdit(rec),
                show: () => true,
                disabled: () => false,
              },
              {
                key: 'delete',
                title: 'Excluir',
                icon: <DeleteOutlineIcon />,
                onClick: deleteHundle,
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
      </Card>
      <Dialogo ref={refDialogoCompra} />
      <DialogoDeleteResource ref={refDialogoDeleteResource} />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao="publico">
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Clientes Televendas"
    />
  </ProtegerPagina>
);

export default List2;
